function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Icons/Customers");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Icons/Customers",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.97460938,10.3369141 C11.6015625,10.3369141 12.9277344,8.88769531 12.9277344,7.12402344 C12.9277344,5.37402344 11.6083984,4 9.97460938,4 C8.35449219,4 7.02148438,5.40136719 7.02148438,7.13769531 C7.02832031,8.89453125 8.34765625,10.3369141 9.97460938,10.3369141 Z M9.97460938,9.3046875 C8.9765625,9.3046875 8.12207031,8.34765625 8.12207031,7.13769531 C8.12207031,5.94824219 8.96289062,5.03222656 9.97460938,5.03222656 C10.9931641,5.03222656 11.8271484,5.93457031 11.8271484,7.12402344 C11.8271484,8.33398438 10.9794922,9.3046875 9.97460938,9.3046875 Z M14.2675781,16.6601562 C15.4023438,16.6601562 15.9423828,16.3183594 15.9423828,15.5664062 C15.9423828,13.7753906 13.6796875,11.1845703 9.97460938,11.1845703 C6.26269531,11.1845703 4,13.7753906 4,15.5664062 C4,16.3183594 4.54003906,16.6601562 5.67480469,16.6601562 L14.2675781,16.6601562 Z M14.5957031,15.6279297 L5.35351562,15.6279297 C5.17578125,15.6279297 5.10058594,15.5800781 5.10058594,15.4365234 C5.10058594,14.3154297 6.83691406,12.2167969 9.97460938,12.2167969 C13.1054688,12.2167969 14.8417969,14.3154297 14.8417969,15.4365234 C14.8417969,15.5800781 14.7734375,15.6279297 14.5957031,15.6279297 Z",
  id: "Customers",
  fill: "#14006B",
  fillRule: "nonzero"
}));

var SvgCustomers = function SvgCustomers(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCustomers, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/customers.7c96f56d.svg";
export { ForwardRef as ReactComponent };